import {
  SeatStyledButton,
  SettingsSectionWrapper1,
  SettingsSectionWrapper2,
} from "../../pageComponents/settings/style";
import {
  Box,
  Typography,
  Paper,
  Divider,
  CircularProgress,
  Chip,
  Button,
} from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { ButtonText, HeaderButton2 } from "../../pageComponents/style";
import { PaymentSagaActions } from "../../store/payment/sagas";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isLoadingSelector,
  userCardDetailsSelector,
} from "../../store/payment/selector";
import routeConstant from "../../utils/routeConstant";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { CustomButton } from "../../globalStyle";
import { theme } from "../../utils/theme";
import { CreateNewIcon } from "../../assets/Icons";

const PaymentMethods = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userCardDetails = useSelector(userCardDetailsSelector);
  const isLoading = useSelector(isLoadingSelector);

  useEffect(() => {
    dispatch(PaymentSagaActions.GetUserCardDetails());
  }, [dispatch]);

  const handleUpdatePaymentDetails = () => {
    navigate(`${routeConstant?.paymentCheckout}/dropin/updatePaymentDetails`);
  };

  const handleSetDefaultCard = (cardId: string) => {
    dispatch(PaymentSagaActions.handleSetDefalutSaveCard({ cardId }));
  };
  return (
    <SettingsSectionWrapper1>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 3,
          mb: 3,
        }}
      >
        <CustomButton
          variant="contained"
          size="small"
          sx={{
            padding: "0.625rem 1.25rem",
            fontSize: "1rem",
            fontWeight: "500",
            borderRadius: "1.786rem !important",
            color: "white !important",
            background: `${theme.colors.backgroundPrimary} !important`,
            height: "2.6rem",
            width: "fit-content",
            alignSelf: "flex-end",
            cursor: "pointer",
          }}
          onClick={() => handleUpdatePaymentDetails()}
        >
          <CreateNewIcon fill="white" />
          <ButtonText>Add New Card</ButtonText>
        </CustomButton>
      </Box>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "40vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : userCardDetails.length ? (
        <Box sx={{ display: "flex", gap: 3, width: "100%", flexWrap: "wrap" }}>
          {userCardDetails?.map((card: any, index: number) => (
            <Paper
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 3,
                width: "100%",
                maxWidth: 400,
                background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
                color: "#fff",
                position: "relative",
                overflow: "hidden",
                boxShadow: card.isDefault
                  ? "0px 0px 20px rgba(30, 60, 114, 0.6)"
                  : "0px 2px 10px rgba(0, 0, 0, 0.1)",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: card.isDefault
                    ? "0px 0px 25px rgba(30, 60, 114, 0.8)"
                    : "0px 4px 12px rgba(0, 0, 0, 0.15)",
                },
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='240' viewBox='0 0 400 240'><path fill='%23ffffff11' d='M0,80 C50,140 150,20 200,80 C250,140 350,20 400,80 L400,240 L0,240 Z'/><path fill='%23ffffff22' d='M0,160 C50,220 150,100 200,160 C250,220 350,100 400,160 L400,240 L0,240 Z'/></svg>")`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  opacity: 0.6,
                  zIndex: 0,
                },
              }}
              key={index}
            >
              {/* Top Branding */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={4}
              >
                <Typography fontWeight={600} fontSize={20}>
                  Card Details
                </Typography>
                {/* Default Card Badge */}
                {card?.isDefault ? (
                  <Chip
                    icon={
                      <CheckCircleIcon
                        sx={{
                          width: "20px",
                          height: "20px",
                          color: "#ffffff !important",
                        }}
                      />
                    }
                    label="Default Card"
                    sx={{
                      backgroundColor: "#ffffff22",
                      color: "#fff",
                      border: "1px solid #ffffff55",
                      fontWeight: 500,
                      height: "28px",
                      fontSize: "14px",
                    }}
                  />
                ) : (
                  <SeatStyledButton
                    onClick={() => handleSetDefaultCard(card?._id)}
                    sx={{
                      color: "#fff !important",
                      border: "1px solid #fff !important",
                      "&:hover": {
                        background: "#ffffff22 !important",
                      },
                    }}
                  >
                    Mark as Default Card
                  </SeatStyledButton>
                )}
              </Box>

              {/* Chip and Card Number */}
              <Box display="flex" alignItems="center" gap={2} mb={4}>
                <Box
                  sx={{
                    width: 40,
                    height: 30,
                    borderRadius: "6px",
                    background: "linear-gradient(45deg, #d4af37, #f5d76e)",
                  }}
                />
                <Typography fontSize={24} letterSpacing={2}>
                  **** **** **** {card.lastFourDigits}
                </Typography>
              </Box>

              {/* Card Holder & Expiry */}
              <Box display="flex" justifyContent="space-between">
                <Box>
                  <Typography fontSize={12} color="#ccc">
                    Card Holder
                  </Typography>
                  <Typography fontSize={16} fontWeight="bold">
                    {card.cardHolderName || "N/A"}
                  </Typography>
                </Box>

                <Box>
                  <Typography fontSize={12} color="#ccc">
                    Expiry Date
                  </Typography>
                  <Typography fontSize={16} fontWeight="bold">
                    {card.expiryDate}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            minHeight: "40vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" color="text.secondary">
            Looks like you haven’t added a payment method yet!
          </Typography>
        </Box>
      )}
    </SettingsSectionWrapper1>
  );
};

export default PaymentMethods;
